import { CoreType, GenericTableSchemaInterface, UserVars, StoreVars } from '../../swivl-lib'
import { BotVariables } from '@swivl/swivl-worksheets-lib'

export const FMSPlusPaymentSuccess00Table: GenericTableSchemaInterface = {
  id: 'fms-plus-payment-success-00',
  name: 'FMS+ Payment Success 00',
  description:
    'This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Success workflows.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: BotVariables.Bot_Operator_Name
    },
    c02: {
      name: 'Facility ID',
      variable: StoreVars.StoreId
    },
    c03: {
      name: 'Tenant ID',
      variable: UserVars.User_TenantId
    },
    c04: {
      name: 'As soon as payment is confirmed SMS'
    },
    c05: {
      name: 'As soon as payment is confirmed Email'
    }
  }
}
